import { GetStaticProps } from 'next'
import { Newsletter } from 'src/pages/Newsletter'
import { getNewsletters } from 'src/services/newsletterServices'

export default Newsletter

export const getStaticProps: GetStaticProps = async () => {
  const data = await getNewsletters()
  return {
    props: { serverNewsletters: data },
    revalidate: 10 * 60,
  }
}
